import store from "@/config/vuex/store";

export default [
    {
        path: "/adm",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [           
            {
                path: "compras-analitico",
                name: "admComprasAnaliticoRead",
                component: () => import('@/pages/Adm/AdmComprasAnaliticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "compras-sintetico",
                name: "admComprasSinteticoRead",
                component: () => import('@/pages/Adm/AdmComprasSinteticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

